import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchSituations, fetchedSituations } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchSituations>;

export function* getSituationsSaga({ meta: { callback } }: FetchActionPayload) {
  const { getSituations } = getAPI();
  // TODO: add type response: YieldOf<typeof getSituations> ===> then fix issues between the callApi and the action that uses data
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const response = yield call(getSituations);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedSituations(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedSituations(undefined, error));
  }

  if (callback) callback();
}

export default function* situationsSaga() {
  yield takeLatest(fetchSituations.type, getSituationsSaga);
}
